import { $$ } from "../../sharedscripts/OO_jquery";
export function scrollModify(lock, submodifer) {
  let scrolls = [".ios-scroll"];
  if (submodifer) {
    scrolls = [".item-details"];
  }
  const bodyScrollLock = require("body-scroll-lock");
  bodyScrollLock.clearAllBodyScrollLocks();
  const options = {
    reserveScrollBarGap: true,
  };
  if (isIos()) {
    setTimeout(() => {
      scrolls.forEach((elm) => {
        var targetElement = $$(elm);
        for (var i = 0; i < targetElement.length; i++) {
          if (lock) {
            bodyScrollLock.disableBodyScroll(targetElement[i], options);
          } else {
            bodyScrollLock.enableBodyScroll(targetElement[i]);
            bodyScrollLock.clearAllBodyScrollLocks();
          }
        }
      });
    }, 100);
  }
}
export function isIos() {
  return !!navigator.platform.match(/iPhone|iPod|iPad/);
}

export function normalizeQueryParams(query) {
  const normalizedQuery = {};
  Object.keys(query).forEach(key => {
    normalizedQuery[key.toLowerCase()] = query[key];
  });
  return normalizedQuery;
}
